
<div style="display: flex; flex-direction: row; flex-wrap: wrap;">
  <div style="align-content: center; text-align: center; margin-right: 20px;">
    <img src="../../assets/img/icons8-user-shield-48.png" style="height: 48px;"/><br/>
    <span style="font-size: large; font-weight: bold;">{{this.Player?.Player.FirstName }} {{Player?.Player.LastName}}</span><br/>
    <span style="font-size: small; ">
      {{this.Player?.Player.DateOfBirth | date: 'yyy-MM-dd'}}
    </span>
  </div>
  <div >

    <table>
      <tr>
        <td>Current age:</td>
        <td>
          {{this.Player?.PlayerAgeYears }} years {{this.Player?.PlayerAgeMonths }} months
        </td>
      </tr>
      <tr>
        <td>Position:</td>
        @if (this.Player?.Player.PositionId==1) {
          <td>
            Goaltender
          </td>
        }
        @if (this.Player?.Player.PositionId==2) {
          <td>
            Defender
          </td>
        }
        @if (this.Player?.Player.PositionId==3) {
          <td>
            Forward
          </td>
        }
        @if (this.Player?.Player.PositionId==4) {
          <td>
            Center
          </td>
        }
        @if (this.Player?.Player.PositionId==5) {
          <td>
            Forward
          </td>
        }
      </tr>
      <tr>
        <td>Height:</td>
        <td>{{this.Player?.Player.Height }} cm</td>
      </tr>
      <tr>
        <td>Weight:</td>
        <td>{{this.Player?.Player.Weight }} kg</td>
      </tr>
      <tr>
        <td>Shoots:</td>
        @if (this.Player?.Player.ShootId==1) {
          <td>L</td>
        }
        @if (this.Player?.Player.ShootId==2) {
          <td>R</td>
        }
      </tr>

    </table>

  </div>
  <!--  <div>
  <span style="font-family: Roboto; font-size: small;">Teams</span>
  <div *ngFor="let team of this._playerData?.playerteams" style="font-family: Roboto;">
    <img [src]="'../assets/img' + team.SmallIconFileName" style="height: 20px;"/>
    <b>{{ team.JerseyNo }}</b>&nbsp;{{team.Division}} - {{team.Name}}
  </div>
</div> -->
</div>
